export default __webpack_public_path__ + "static/dismoi-screenshot-amazon-antidote-mounted-website-desktop-3db69546a739b3499da0d4d215dac3f6.jpg";